import { ActionTree } from 'vuex'
import { WidgetState } from "@/apps/StudentExchangeInformationColumnWidget/models/store-viewmodel"
import { ILabels } from "@/apps/StudentExchangeInformationColumnWidget/models/config-viewmodel"

export default <ActionTree<WidgetState, any>>{
    setLabels(context, payload: ILabels): void {
        context.commit('labels', payload)
    },
    setModalOpen(context, payload: boolean): void {
        context.commit('isModalOpen', payload)
    },
    setOffset(context, payload: number): void {
        context.commit('offset', payload)
    }
}
